export default __webpack_public_path__ + "static/media/mode-42.9d1c6b23.svg";